<template lang="pug">
#betslip-single.modal.modal-bottom.fade.modal-betslip(tabindex='-1' role='dialog' aria-labelledby='betslip-single' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-body
        .d-flex.justify-content-end
          .close-btn(data-bs-dismiss='modal' @click="hideMe()")
            i.fa-solid.fa-xmark
        template(v-if="!isDataExists")
          .bet-slip
            .bet-slip-wrapper 
              .stake-info-wrapper
                //- span {{ $t("ui.no_bet") }}  
                .stake-info
                  .betslip-match.text-left(v-if="!loading.check") {{ $t("message.bet_empty") }}
                  .betslip-match(v-else)
                    i.fad.fa-spinner.fa-spin
        template(v-else)
          .bet-slip
            .bet-slip-wrapper(:class="{ live: betsingle.marketType == 3 }")
              .close(@click="hideMe()")
                i.fa-solid.fa-xmark  
              .stake-info-wrapper
                .bet-type
                  img.icon(:src="'images/light/sport/white/' + getSportsImage(betsingle.sportsType) + '.svg'")
                  template(v-if="racingList.includes(betsingle.sportsType)")
                    | {{ sports[betsingle.sportsType] }}
                  template(v-else)
                    | {{ sports[betsingle.sportsType] }} - {{ betTypeDisplay }}
                .stake-info
                  .betslip-league {{ betsingle.leagueName }}
                  .betslip-match
                    .team-involved
                      span.score(v-if="betsingle.marketType == 3 && betsingle.score != ''") [{{ betsingle.score }}]
                      template(v-if="racingList.includes(betsingle.sportsType)")
                        template(v-if="racingList2.includes(betsingle.sportsType)")
                          template(v-if="['ML','1X2'].includes(betsingle.betType)")
                            span {{ betsingle.homeAway == 1 ? betsingle.homeName : betsingle.awayName }}
                          template(v-if="['OU','OE'].includes(betsingle.betType)")
                            span {{ betsingle.homeAway == 1 ? betsingle.homeName : betsingle.awayName }}
                          template(v-if="['CS'].includes(betsingle.betType)")
                            span {{ ['5-0','4-1','3-2'].includes(betsingle.betDisplay) ? betsingle.homeName : betsingle.awayName }}
                        template(v-else-if="racingList6.includes(betsingle.sportsType) || racingList7.includes(betsingle.sportsType)")
                          template(v-if="['ML'].includes(betsingle.betType)")
                            span {{ betsingle.homeAway == 1 ? betsingle.homeName : betsingle.awayName }}
                          template(v-else-if="['CS','OE'].includes(betsingle.betType)")
                            span {{ betsingle.homeName }} vs {{ betsingle.awayName }}
                        template(v-else)
                          span {{ betsingle.homeName }}
                        span.small.ml-1(v-if="racingList.includes(betsingle.sportsType) && betsingle.matchTime")  (No. {{ $dayjs(betsingle.matchTime).format("MMDDhhmm") }})
                      template(v-else)
                        span.d-block(:class="betsingle.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsingle.homeName }}
                        span.d-block(:class="betsingle.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsingle.betType != 'OR'") {{ betsingle.awayName }}
                  .selector-odd
                    template(v-if="racingList.includes(betsingle.sportsType)")
                      template(v-if="racingList1.includes(betsingle.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GH_" + betsingle.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else) {{ $t("m.GH_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                      template(v-if="racingList2.includes(betsingle.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GC_" + betsingle.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else-if="['CS'].includes(betsingle.betType)") {{ betsingle.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.GC_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                      template(v-if="racingList3.includes(betsingle.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GX_" + betsingle.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else) {{ $t("m.GX_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                      template(v-if="racingList4.includes(betsingle.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GR_" + betsingle.betDisplay.toUpperCase()) }} 
                        span.bet-type-text(v-else-if="['ML','1X2'].includes(betsingle.betType)") {{ $t("m.GR_" + betsingle.betType + betsingle.betDisplay.toUpperCase().replace(".","")) }} 
                        span.bet-type-text(v-else-if="['CS'].includes(betsingle.betType)") {{ betsingle.betDisplay }} 
                        span.bet-type-text(v-else) {{ $t("m.GR_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                      template(v-if="racingList5.includes(betsingle.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.MA_" + betsingle.betType + (betsingle.homeAway == undefined ? '' : betsingle.homeAway)) }}
                        template(v-else-if="['ML'].includes(betsingle.betType)")
                          template(v-if="betsingle.homeName == betsingle.awayName")
                            span.bet-type-text(v-if="betsingle.homeAway==1")   {{ $t("m.MA_ANY_W_R")   }}
                            span.bet-type-text(v-else)   {{ $t("m.MA_NO_W_R")   }}
                          span.bet-type-text(v-else)  {{ $t("m.MA_" + betsingle.betType + (betsingle.homeAway == undefined ? '' : betsingle.homeAway)) }}
                        template(v-else-if="['CS'].includes(betsingle.betType)")
                          span.bet-type-text(v-if="betsingle.criteria2")  {{ betsingle.criteria2 }} 
                          template(v-else-if="betsingle.homeName == betsingle.awayName")
                            span.bet-type-text(v-if="['3-0'].includes(betsingle.betDisplay)")  {{ $t("m.MA_PF") }}
                            span.bet-type-text(v-else) {{ $t("m.MA_W_" + betsingle.betDisplay.split('-')[0]) }}
                          span.bet-type-text(v-else) {{ betsingle.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.MA_" + betsingle.betType) }}
                      template(v-if="racingList6.includes(betsingle.sportsType) || racingList7.includes(betsingle.sportsType)")
                        span.bet-type-text(v-if="['ML','OE'].includes(betsingle.betType)") {{ $t("m.CF_" + betsingle.betType + (betsingle.homeAway == undefined ? '' : betsingle.homeAway)) }}
                        span.bet-type-text(v-else-if="['CS'].includes(betsingle.betType)") {{ betsingle.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.CF_" + betsingle.betType) }}
                      .bet-type-odds
                        .odds
                          span(:class="{ 'negetive' : betsingle.val < 0 }") {{ betsingle.val }}
                    template(v-else)
                      span.text
                        span.market-type {{ betsingle.betType }}
                        span.team-name(:class="isBallDisplay == false ? '' : ((betsingle.giving == 0 && betsingle.homeAway == 2) ? 'team2' : (betsingle.giving == 1 && betsingle.homeAway == 1) ? 'team2' : 'team1')")   
                          template(v-if="[40].includes(betsingle.sportsType)")
                            template(v-if="['OU'].includes(betsingle.betType) && ballDisplay == 4.5")
                              | {{ betsingle.betDisplay.toUpperCase() == 'OVER' ? $t("m.D_BIG") : $t("m.D_SMALL") }}
                            template(v-else)
                              | {{ betsingle.betDisplay }}
                          template(v-else)
                            | {{ betsingle.betDisplay }}
                            template(v-if="!!time_machine.minutesOddsData && time_machine.minutesOddsData.length> 0") 
                              | {{ (checkTeam(betsingle) === 1 ? betsingle.homeName : betsingle.awayName)}}
                              template(v-if="!!betsingle.tm_time") {{  displayTimeRange(betsingle.tm_time) }}
                        template(v-if="['1X2OU', 'DCOU', 'OUOE'].includes(betsingle.betType)") &nbsp;({{ betsingle.criteria2 }})
                      .bet-type-odds
                        span.bet-type-text {{ ballDisplay }}
                        .odds(:class="{ 'negetive' : betsingle.val < 0 }") {{ betsingle.val }}
            .odds-change-notice(v-if="betsingle.oddsChanged && !checkIsTM()")
              i.fas.fa-exclamation-circle.text-warning
              span  {{ $t("message.odds_changed") }} {{ betsingle.oddsChangedText }} &#8594; {{ betsingle.val }}
            .odds-change-notice(v-if="oddsIsUpdating || invalidOdds")
              i.fas.fa-exclamation-circle.text-warning
              span  {{ $t("error.oddsIsUpdating") }}
            .odds-change-notice(v-if="stopBet")
              i.fas.fa-exclamation-circle.text-warning.me-1
              span {{ $t("error.marketClose") }}
            .odds-change-notice(v-if="errorMessage")
              i.fas.fa-exclamation-circle.text-danger
              span  {{ errorMessage }}
            .footer-slip.text-left
              .payout-wrapper
                .left 
                  | {{ $t("ui.min") }}: 
                  span {{ $numeral(betsingle.minBet).format("0,0") }} | 
                  | {{ $t("ui.max") }}: 
                  span {{ $numeral(betsingle.maxBet).format("0,0") }}
                .right 
                  | {{ $t("ui.payout") }}: 
                  span {{ $numeral(payout).format("0,0.00[0]") }}
              .stake-wrapper
                .d-flex.justify-content-between.flex-fill.mr-1.bet-input
                  .d-flex.align-items-center.flex-fill.px-2.mr-1.stake-input-wrapper
                    .stake-mask(@click="runTapAction(maskStake, $event)" @touchend="runTapAction(maskStake, $event)")
                      StakeInput(v-model="stake" @handleStake="handleStake" ref="stake" :loadbet="loading.check")
                    .stake-cancel(v-show="showStakeCancel" @click="clearStake")
                      i.fas.fa-times
                SpinButton#place-bet.place-bet.btn-sm(@click="processConfirmBet" :text="$t('ui.process_bet')" :loading="loading.process")
              .betslip-cashout.p-2(v-if="betsingle.cashout")
                span.text-success
                  i.fas.fa-check-circle
                span(style='opacity: .5;') {{ $t("ui.cashout") }}:
                span.text-success {{ $t("ui.available") }}
              .keyboard(@click="handleKeyboardInteraction" @touchend="handleKeyboardInteraction")
                .cluster
                  .add-stake-wrapper
                    .add-stake(data-kb="min")
                      span {{ $t("ui.min") }}
                    .add-stake(data-kb="add:50")
                      span + 50
                    .add-stake(data-kb="add:100")
                      span + 100
                    .add-stake.btn-max(data-kb="max")
                      span {{ $t("ui.max") }}
                .cluster
                  .num-wrapper
                    .button-tap(data-kb="1")
                      span 1
                    .button-tap(data-kb="2")
                      span 2
                    .button-tap(data-kb="3")
                      span 3
                    .button-tap(data-kb="4")
                      span 4
                    .button-tap(data-kb="5")
                      span 5
                    .button-tap.del(data-kb="del")
                      span DEL
                  .num-wrapper  
                    .button-tap(data-kb="6")
                      span 6
                    .button-tap(data-kb="7")
                      span 7
                    .button-tap(data-kb="8")
                      span 8
                    .button-tap(data-kb="9")
                      span 9
                    .button-tap(data-kb="0")
                      span 0
                    .button-tap(data-kb="00")
                      span 00
              .bet-infosub
                .checkbox
                  label.d-flex(@click="handleAcceptBetterOdds")
                    input(type="checkbox" :checked="betting.acceptBetterOdds == 'true'")
                    span.label(@click="handleAcceptBetterOdds") {{ $t("ui.accept_better_odds") }}
                .checkbox
                  label.d-flex(@click="handleRememberStake")
                    input(type="checkbox" :checked="betting.defaultStake == '0'")
                    span.label(@click="handleRememberStake") {{ $t("ui.remember_stake") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import xhrBet from "@/library/_xhr-bet.js";
import calc from "@/library/_calculation.js";
import config from "@/config";
import StakeInput from "@/components/mobile/bets/new/stakeInput";
import SpinButton from "@/components/ui/SpinButton";
import mixinBetType from "@/library/mixinBetType";
import mixinDelay from "@/library/mixinDelay";
import mixinKeyboardTap from "@/library/mixinKeyboardTap";
import naming from "@/library/_name";

export default {
  components: {
    SpinButton,
    StakeInput
  },
  mixins: [mixinBetType, mixinDelay, mixinKeyboardTap],
  data() {
    return {
      errorMessage: "",
      debounceBet: null,
      loading: {
        check: false,
        cancel: false,
        process: false
      },
      league: {},
      match: {},
      defaultCounter: 10,
      counter: 10,
      placeSlip: {},
      stake: null,
      customStake: null,
      payout: null,
      invalidOdds: false,
      oddsIsUpdating: false,
      autoCloseOddsIsUpdating: null,
      stopBet: false,
      autoCloseOddsIsStopBet: null,
      betConfirm: false,
      setParlay: false,
      isMMO: false,
      singleOdds: null,
      oddsType: null,
      oddsPosition: null,
      isNewData: false
    };
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    racingList4() {
      return config.racingList4;
    },
    racingList5() {
      return config.racingList5;
    },
    racingList6() {
      return config.racingList6;
    },
    racingList7() {
      return config.racingList7;
    },
    ballDisplay() {
      return naming.ballDisplay2(this.betsingle.ballDisplay, this.betsingle.giving, this.betsingle.homeAway, this.betsingle.betType, this);
    },
    isBallDisplay() {
      var result = naming.ballDisplay2(this.betsingle.ballDisplay, this.betsingle.giving, this.betsingle.homeAway, this.betsingle.betType, this);
      if (["HDP", "HDPH"].includes(this.betsingle.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    betTypeDisplay() {
      return this.$t("m.BS_" + this.betsingle.betType);
    },
    commType() {
      return this.$store.getters.commType;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    debug() {
      return config.debugMode;
    },
    betsingle() {
      return this.$store.state.betsingle;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace("UST", "USDT");
    },
    isDataExists() {
      if (this.betsingle.hasOwnProperty("val")) {
        return true;
      } else {
        return false;
      }
    },
    betsingleValue() {
      return this.betsingle.val;
    },
    betsingleMulti() {
      return this.betsingle.multi;
    },
    betparlay() {
      return this.$store.state.betparlay;
    },
    checkAddParlay() {
      for (var n in this.betparlay) {
        if (this.betparlay[n].oddsId == this.betsingle.oddsId && this.betparlay[n].betTeamId == this.betsingle.betTeamId) {
          return true;
        }
      }
      return false;
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    time_machine() {
      return this.$store.getters.timeMachine || {};
    }
  },
  watch: {
    stake(newVal) {
      this.handlePayout();
    },
    betsingleValue(newVal) {
      this.handlePayout();
    },
    betsingleMulti(newVal) {
      this.handlePayout();
    }
  },
  destroyed() {
    $("#betslip-single").off("shown.bs.modal", this.handleShownMe);
    $("#betslip-single").off("hidden.bs.modal", this.handleHiddenMe);
    clearInterval(this.runner);
  },
  mounted() {
    this.debounceBet = this.debounce(this.processBet, 200);
    setInterval(this.runner, this.defaultCounter * 1000);
    EventBus.betSingle = this.runbet;
    EventBus.cancelSingle = this.cancelBet;

    $("#betslip-single").on("shown.bs.modal", this.handleShownMe);
    $("#betslip-single").on("hidden.bs.modal", this.handleHiddenMe);
  },
  methods: {
    handleShownMe() {
      $("#place-bet").show();
      this.armKeyboardGuard();
      this.$nextTick(() => {
        this.showKeyboard();
      });
    },
    handleHiddenMe() {
      // $(".odd-value").removeClass("selected-odds");
      // $(".odd").removeClass("selected-odds");
      $("#place-bet").show();
      this.cancelBetClick();
    },
    getBallDisplay(b, g, ha, bt) {
      return naming.ballDisplay2(b, g, ha, bt, this);
    },
    runbet(odds, typ, idx, val, bt, amt, allowParlay, isMMO, e, fromTimeMachine) {
      if (isMMO) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.invalidCurrency"), "error");
        return;
      }
      if (EventBus.cancelSingleMMO) EventBus.cancelSingleMMO();

      if (!fromTimeMachine && this.checkIsTM()) {
        this.$store.commit("timemachine/RESET_STATE");
      }
      this.isNewData = true;

      this.showMe();
      this.loading.process = false;
      this.singleOdds = odds;
      this.oddsType = typ;
      this.setParlay = allowParlay;
      this.isMMO = isMMO;
      this.oddsPosition = idx;
      this.stake = "";
      this.customStake = null;
      this.errorMessage = "";
      this.betConfirm = false;
      this.handleStake();
      this.checkSingleBet(odds, typ, idx, val, bt, e);
      this.armKeyboardGuard();
      this.bindKeyboard();
      this.$nextTick(() => {
        this.showKeyboard();
        if (this.$refs.stake) {
          this.$refs.stake.focus();
        }
      });
      clearTimeout(this.autoCloseOddsIsUpdating);
      clearTimeout(this.autoCloseOddsIsStopBet);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
      this.stopBet = false;
    },

    addParlay() {
      if (this.checkAddParlay) {
        if (EventBus.closeParlay) {
          EventBus.closeParlay(this.betsingle.matchId);
        }
        return;
      }

      var parlayOdds = calc.convertSingleToParlay(this.commType, this.oddsType, this.singleOdds, true);
      if (EventBus.betParlay) {
        EventBus.betParlay(parlayOdds, this.oddsType, this.oddsPosition, parlayOdds[this.oddsPosition], "parlay", this.stake);
      }
    },
    runner() {
      if (!this.stopBet) {
        clearInterval(this.runner);
      }
      this.autoRefresh();
    },
    cache() {
      return this.$store.getters.data;
    },
    bindKeyboard() {
      document.onkeyup = event => {
        if (event.which == 13 || event.keyCode == 13) {
          this.processConfirmBet();
        } else {
          if (event.which == 27 || event.keyCode == 27) {
            this.cancelBet("bindKeyboard");
          }
        }
      };
    },
    // fastBet() {
    //   if (this.isDataExists) {
    //     this.handleStake();
    //     this.$swal({ title: this.$t("ui.confirmation"), text: this.$t("message.confirmation"), type: "info", showCancelButton: true }).then(result => {
    //       if (result.value) {
    //         this.processConfirmBet();
    //       }
    //     });
    //   }
    // },
    processConfirmBet() {
      if (!!this.stopBet) return;
      if (!this.validateStakeForPlaceBet()) {
        return;
      }
      this.loading.process = false;
      this.betConfirm = true;
      this.loadingBet();
    },
    cancelProcess() {
      this.betConfirm = false;
    },
    getBetLimit(st) {
      var result = {
        min_bet: 0,
        max_bet: 0,
        max_payout: 0
      };
      if (st) {
        switch (parseInt(st)) {
          case 1:
            result = this.$store.getters.playerBetLimit["SOCCER"];
            break;
          case 2:
            result = this.$store.getters.playerBetLimit["BASKETBALL"];
            break;
          case 7:
            result = this.$store.getters.playerBetLimit["TENNIS"];
            break;
          case 8:
            result = this.$store.getters.playerBetLimit["BASEBALL"];
            break;
          case 20:
            result = this.$store.getters.playerBetLimit["ESPORTS"];
            break;
          default:
            result = this.$store.getters.playerBetLimit["OTHERS"];
            break;
        }
      }

      return result;
    },
    showMe() {
      $("#betslip-single").modal("show");
    },
    hideMe() {
      document.activeElement.blur();
      $("#betslip-single").modal("hide");
    },
    handlePayout() {
      var a = this.stake * this.betsingle.multi;
      var b = this.betsingle.maxBet * this.betsingle.multi;
      if (a > b) {
        a = b;
      }
      this.payout = a.toFixed(3);
      this.$store.dispatch("betsingle/setStake", this.stake);
    },
    handleStake() {
      if (!!this.stopBet) return;
      if (this.stake % 1 != 0) {
        this.stake = Math.round(this.stake);
      }
    },
    forceHandleStake() {
    },
    clearStake() {
      this.stake = "";
    },
    minStake() {
      if (!!this.stopBet) return;
      this.stake = this.betsingle.minBet;
    },
    maxStake() {
      this.stake = this.betsingle.maxBet;
    },
    maskStake() {
    },
    keyStake(e) {
      if (!!this.stopBet) return;
      this.stake = this.buildStakeFromDigit(e);
    },
    deleteStake() {
      var c = this.getStakeString();
      if (c.length > 0) {
        this.stake = c.slice(0, -1);
        this.handleStake();
      }
    },
    doneStake() {
      $("#place-bet").show();
    },

    refreshOddsYes() {
      this.invalidOdds = false;
      this.counter = this.defaultCounter;
      this.requestSingleBet(this.betsingle, "refresh");
    },
    refreshOddsNo() {
      this.invalidOdds = false;
    },
    checkMatchExists() {
      var result = true;
      if (this.betsingle != null) {
        var cache = this.cache();
        if (cache != null && cache.hasOwnProperty("match")) {
          if (!cache.match.hasOwnProperty(this.betsingle.matchId)) {
            result = false;
            this.cancelBet("checkMatchExists");
          }
        } else {
          result = false;
          this.cancelBet("checkMatchExists");
        }
      }
      return result;
    },
    autoRefresh() {
      if (this.isDataExists) {
        if ((this.betting.autoRefreshOdds == true || this.betting.autoRefreshOdds == "true") && this.isDataExists) {
          if (this.isNewData) this.isNewData = false;
          this.requestSingleBet(this.betsingle, "refresh");
        }
      }
    },
    handleAutoRefresh() {
      this.$store.dispatch("layout/setSingleBetting", { property: "autoRefreshOdds", value: this.betting.autoRefreshOdds == "true" ? "false" : "true" });
      this.counter = this.defaultCounter;
    },
    handleAcceptBetterOdds() {
      this.$store.dispatch("layout/setSingleBetting", { property: "acceptBetterOdds", value: this.betting.acceptBetterOdds == "true" ? "false" : "true" });
    },
    handleRememberStake() {
      this.$store.dispatch("layout/setSingleBetting", { property: "defaultStake", value: this.betting.defaultStake == "0" ? "3" : "0" });
    },
    loadingBet() {
      this.loading.process = true;
      if (this.debounceBet) {
        this.debounceBet();
      }
    },
    processBet() {
      if (!this.betConfirm || Object.keys(this.betsingle).length <= 3) return;
      if (!this.validateStakeForPlaceBet()) {
        return;
      }
      this.betConfirm = false;
      this.loading.process = true;
      var old = this.placeSlip;
      this.placeSlip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        odds_id: this.betsingle.oddsId,
        submatch_id: this.betsingle.subMatchId,
        match_id: this.betsingle.matchId,
        bet_type: this.betsingle.betType,
        bet_member: this.stake,
        bet_team_id: this.betsingle.betTeamId,
        home_away: this.betsingle.homeAway,
        odds_display: parseFloat(this.betsingle.val),
        odds_mo: parseFloat(this.betsingle.origin),
        odds_type: this.betsingle.typId,
        accept_better_odds: this.betting.acceptBetterOdds,
        ball_display: this.betsingle.ballDisplay,
        operator_type: this.$store.getters.operatorType,
        parent_id: this.$store.getters.parentId,
        market_type: this.betsingle.marketType,
        odds_col: this.betsingle.idx - 5
      };

      if (this.checkIsTM()) {
        this.placeSlip.end_time = this.betsingle.idx;

        const tOdds = this.getOddsByMinute(this.time_machine.minutesOddsData, this.betsingle.idx);
        if (this.betsingle.betType === "HDP") {
          if (this.betsingle.homeAway === 2) {
            this.placeSlip.o_tm_d = tOdds["ha"];
            this.placeSlip.o_tm_m = tOdds["haa"];
          } else {
            this.placeSlip.o_tm_d = tOdds["hh"];
            this.placeSlip.o_tm_m = tOdds["hha"];
          }
        } else if (this.betsingle.betType === "OU") {
          if (this.betsingle.homeAway === 2) {
            this.placeSlip.o_tm_d = tOdds["ud"];
            this.placeSlip.o_tm_m = tOdds["uda"];
          } else {
            this.placeSlip.o_tm_d = tOdds["ov"];
            this.placeSlip.o_tm_m = tOdds["ova"];
          }
        }
      }

      // console.log(this.betsingle.idx, this.betsingle.special);
      old = null;
      var cloneSlip = Object.assign({}, this.betsingle);
      cloneSlip.stake = this.stake.toString();
      cloneSlip.payout = this.payout.toString();
      xhrBet.betSingle(this.placeSlip, this.betsingle.special, this.checkIsTM()).then(
        res => {
          if (this.$store.state.layout.betting.defaultStake == "0") {
            this.$store.dispatch("layout/setSingleBetting", { property: "defaultStakeAmount", value: this.stake });
          }

          this.hideMe();

          if (EventBus.betSingleStatus) {
            EventBus.betSingleStatus(cloneSlip, res);
          }

          this.cancelBet("processBet");
          if (EventBus.getBalance) {
            EventBus.getBalance();
          }
        },
        err => {
          this.loading.process = false;
          this.handleChecking(err.status, "processBetError");
        }
      );
    },
    handleChecking(e, m) {
      this.loading.check = false;
      switch (e) {
        case "insufficient_balance":
          this.errorMessage = this.$t("error.insufficient_balance");
          break;
        case "betLowerMin":
          this.rejectStakeLimitViolation("min");
          break;
        case "betOverLimit":
        case "betOverMax":
        case "betOverMaxBet":
        case "betOverMaxPerMatch":
          this.rejectStakeLimitViolation("max");
          break;
        case "betAmountRequired":
        case "bet_amount_required":
        case "minBetAmount":
        case "invalidBetAmount":
          this.rejectBetWithFeedback(e);
          break;
        case "invalidOdds":
          this.invalidOdds = true;
          this.refreshOddsYes();
          break;
        case "oddsIsUpdating":
        case "oddsDisplayInvalid":
        case "invalidOddsBall":
          this.oddsIsUpdating = true;
          clearTimeout(this.autoCloseOddsIsUpdating);
          this.autoCloseOddsIsUpdating = setTimeout(() => {
            this.oddsIsUpdating = false;
            this.oddsDisplayInvalid = false;
            this.invalidOddsBall = false;
          }, this.defaultCounter * 1000);
          break;
        case "invalidSliderTimeRange":
        case "invalidMOMatchOdds":
        case "invalidProviderMOMatch":
        case "invalidBet":
        case "invalidBetTime":
        case "oddsPause":
        case "oddsNotAllowedBet":
        case "invalidRTSRunningScoreDetails":
        case "invalidProviderGoalTimeLine":
        case "invalidRTSMatchOdds":
        case "invalidProviderSlider":
        case "invalidCombineBetTypeAndOddsFormat":
        case "invalidRunningLabelAndTime":
        case "invalidTeamScoreAndTotalScore":
        case "betTimeOver":
          this.stopBet = true;
          // clearTimeout(this.autoCloseOddsIsStopBet);
          // this.autoCloseOddsIsStopBet = setTimeout(() => {
          //   this.oddsIsUpdating = false;
          //   this.oddsDisplayInvalid = false;
          //   this.invalidOddsBall = false;
          //   this.stopBet = false;
          // }, this.defaultCounter * 1000);
          break;
        default:
          this.loading.process = false;
          this.betConfirm = false;
          if (m === "processBetError") {
            this.$helpers.handleFeedback(e);
          } else {
            this.cancelBet(m);
            this.$helpers.handleFeedback(e);
          }
          break;
      }
    },
    cancelBetClick() {
      this.cancelBet("cancelBetClick");
    },
    cancelBet(e) {
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
      this.loading.cancel = true;
      this.league = {};
      this.match = {};
      this.counter = this.defaultCounter;
      this.$store.dispatch("betsingle/clearData").then(() => {
        this.loading.cancel = false;
        this.loading.process = false;
      });
      this.loading.check = false;
      this.loading.process = false;
      // $(".odd-value").removeClass("selected-odds");
      $(".odd").removeClass("selected-odds");
    },

    checkSingleBet(odds, typ, idx, val, bt, e) {
      this.counter = this.defaultCounter;
      this.loading.check = true;
      var cache = this.cache();
      if (cache.hasOwnProperty("league") && cache.hasOwnProperty("match")) {
        var sd = {};
        sd.betType = odds[4];
        sd.special = false;
        switch (sd.betType.toUpperCase()) {
          case "CSHTFT":
          case "ETGHTFT":
            sd.special = true;
            break;
        }

        sd.typ = typ;
        sd.idx = idx;
        sd.val = val;
        sd.origin = calc.fmt(val);

        sd.leagueId = odds[0];
        sd.matchId = odds[1];
        sd.subMatchId = odds[2];
        sd.oddsId = odds[3];
        // sd.betType = odds[4];
        sd.ballOrigin = odds[8];
        sd.target = bt;
        if (odds.length == 18 || odds.length >= 79) {
          sd.criteria1 = sd.special ? odds[36] : odds[6];
          sd.criteria2 = sd.special ? odds[37] : odds[7];
        }

        this.league = cache.league[sd.leagueId];
        this.match = cache.match[sd.matchId];

        sd.sportsType = this.league[1];
        sd.leagueId = this.league[0];
        sd.leagueName = this.league[4];

        sd.marketType = this.match[4];
        sd.homeName = this.match[5];
        sd.awayName = this.match[6];
        sd.workingDate = this.match[7];
        sd.matchTime = this.match[8];
        sd.homeId = this.match[22];
        sd.awayId = this.match[23];
        sd.score = this.match[11] ? this.match[11].toString().trim() : "";
        sd.awayId = this.match[23];
        sd.typId = config.oddsTypeId[sd.typ];
        sd.ballDisplay = "";
        sd.betDisplay = "";
        sd.oddsChanged = false;
        sd.ballChanged = false;
        sd.oddsChangedText = "";
        sd.ballChangedText = "";
        var limit = this.getBetLimit(sd.sportsType);
        sd.minBet = limit.min_bet;
        sd.maxBet = limit.max_bet;
        sd.maxPayout = limit.max_payout;

        if (this.checkIsTM()) {
          const tOdds = this.getOddsByMinute(this.time_machine.minutesOddsData, idx);
          if (tOdds["ha"] === val || tOdds["ud"] === val) {
            sd.homeAway = 2;
            sd.betTeamId = this.match[23];
          } else {
            sd.homeAway = 1;
            sd.betTeamId = this.match[22];
          }
        }

        if (sd.typ != "DEC") {
          if (config.marking.includes(sd.betType)) {
            if (sd.val > 0) {
              sd.multi = (parseFloat(sd.val) + 1).toFixed(3);
            } else {
              sd.multi = (Math.abs(parseFloat(sd.val)) + 1).toFixed(3);
            }
          } else {
            sd.multi = sd.val;
          }
        } else {
          sd.multi = sd.val;
        }

        this.setBetType(sd, odds);
        this.$store.dispatch("betsingle/newData", sd);
        this.league = null;
        this.match = null;
        this.requestSingleBet(sd, e);
      }
    },
    requestSingleBet(data, e) {
      this.invalidOdds = false;
      this.errorMessage = "";

      if (data == null) {
        this.cancelBet("requestSingleBetNoData");
        return;
      }

      if (!data.betType || !data.oddsId || !data.sportsType || data.origin == null) {
        this.cancelBet("requestSingleBetInvalid");
        return;
      }

      var slip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        sports_type: data.sportsType,
        parlay: data.target == "parlay",
        odds_id: data.oddsId,
        submatch_id: data.subMatchId,
        bet_type: data.betType,
        bet_team_id: data.betTeamId,
        home_away: data.homeAway,
        odds_display: parseFloat(data.val),
        odds_mo: parseFloat(data.origin),
        odds_type: data.typId,
        ball_display: data.ballDisplay,
        odds_col: data.idx - 5
      };
      if (this.checkIsTM()) {
        slip.bet_member = this.stake;
        slip.homeName = data.homeName;
        slip.awayName = data.awayName;
        slip.end_time = data.idx || this.time_machine.min;
        slip.match_id = this.time_machine.matchId;
      }
      xhrBet.betSingleOddsCheck(slip, data.special, this.checkIsTM()).then(
        res => {
          if (res.success) {
            if (data != null) {
              // var sd = Object.assign({}, data);
              let sd = JSON.parse(JSON.stringify(data));

              sd.cashout = res.data[0].cashout;

              sd.oddsChanged = res.data[0].odds_change;
              sd.ballChanged = res.data[0].ball_change;
              if (res.data[0].home_giving == true) {
                sd.giving = 1;
              } else {
                sd.giving = 0;
              }
              if (res.data[0].ball_display_new != null) {
                sd.ballChangedText = this.getBallDisplay(sd.ballDisplay, sd.giving, sd.homeAway, sd.betType);
                sd.ballDisplay = res.data[0].ball_display_new;
              }
              if (res.data[0].odds_display_new != null) {
                sd.oddsChangedText = sd.val;
                sd.val = calc.fmtType(res.data[0].odds_display_new, this.commType, sd.betType);
              }
              if (res.data[0].odds_new != null) {
                sd.origin = calc.fmt(res.data[0].odds_new);
              }
              if (sd.minBet < res.data[0].min_bet) {
                sd.minBet = res.data[0].min_bet;
              }
              if (sd.maxBet > res.data[0].max_bet) {
                sd.maxBet = res.data[0].max_bet;
              }
              if (sd.maxPayout > res.data[0].max_parlay_payout) {
                sd.maxPayout = res.data[0].max_parlay_payout;
              }
              if (res.data[0].tm_time) {
                sd.tm_time = res.data[0].tm_time;
              }
              if (sd.typ != "DEC") {
                if (config.marking.includes(sd.betType)) {
                  if (sd.val > 0) {
                    sd.multi = (parseFloat(sd.val) + 1).toFixed(3);
                  } else {
                    sd.multi = (Math.abs(parseFloat(sd.val)) + 1).toFixed(3);
                  }
                } else {
                  sd.multi = sd.val;
                }
              } else {
                sd.multi = sd.val;
              }

              this.$store.dispatch("betsingle/setData", sd);
              this.handleStake();
              // setTimeout(() => {
              //   if (this.stake == undefined) {
              //     this.stake = sd.minBet;
              //     if (this.customStake > sd.minBet) {
              //       this.stake = this.customStake;
              //     }
              //     this.$store.dispatch("betsingle/setStake", this.stake);
              //   } else {
              //     if (this.stake < sd.minBet) {
              //       this.stake = sd.minBet;
              //       this.$store.dispatch("betsingle/setStake", this.stake);
              //     }
              //   }
              // }, 10);
              this.loading.check = false;
              this.invalidOdds = false;
            }
          } else {
            this.handleChecking(err.status, "requestSingleBetElse");
          }
        },
        err => {
          this.handleChecking(err.status, "requestSingleBetError");
        }
      );
    },
    checkTeam(betSelected) {
      if (betSelected.giving == 0 && betSelected.homeAway == 2) return 2;
      else if (betSelected.giving == 1 && betSelected.homeAway == 1) return 2;
      else return 1;
    },
    checkIsTM() {
      return !!this.time_machine && !!this.time_machine.minutesOddsData && this.time_machine.minutesOddsData.length > 0;
    },
    displayTimeRange(range_end) {
      const default_start = 0;

      if (this.checkIsTM()) {
        return "(" + [String(default_start).padStart(2, "0") + ":00", String(range_end).padStart(2, "0") + ":00"].join(" - ") + ")";
      } else return "";
    },
    getOddsByMinute(data, min) {
      // Find the object which has the key matching the minute
      const item = data.find(obj => obj.hasOwnProperty(min));
      if (item) return item[min];
      return null; // no odds for this minute
    }
  }
};
</script>
